module.exports = __webpack_public_path__ + "static/media/bindEnterprise1.12c717fa.png";